import { RouteObject } from 'react-router-dom';
import Layout from '../components/Layout';
import HomePage from '../pages/home/page';
import ServicePage from '../pages/service/page';
import WorksPage from '../pages/works/page';
import CompanyPage from '../pages/company/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'service',
        element: <ServicePage />
      },
      {
        path: 'works',
        element: <WorksPage />
      },
      {
        path: 'company',
        element: <CompanyPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default routes;